import { useCallback } from "react";
import { fetchMemberPathway } from "./learnerApi";
import useMemberRead from "./useMemberRead";

/**
 * `GET /client/pathways/{id}`: the pathway home as its learner sees it (contract §5.4):
 * objectives, progress, every level with its evaluated step rows, the weekly prompts
 * (newest first) and the certificate's availability.
 *
 * `notFound` is the contract's 404, identical for absent, draft and not joined. Mount only
 * once a client session exists.
 *
 * @param {string} id the pathway id from the route
 * @returns {{ data: object|null, loading: boolean, error: any, notFound: boolean,
 *             reload: () => Promise<void> }}
 */
export default function useMemberPathway(id) {
  const fetcher = useCallback(() => fetchMemberPathway(id), [id]);
  return useMemberRead(fetcher);
}
